/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ca-central-1",
    "aws_cognito_identity_pool_id": "ca-central-1:42de3d60-cefd-4ac3-ad32-980bf1faf0f4",
    "aws_cognito_region": "ca-central-1",
    "aws_user_pools_id": "ca-central-1_24gwFfqvr",
    "aws_user_pools_web_client_id": "755910a9r3vfm1sdmbuk2shrpd",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "carrentalappa1c6dc66aa17433f8edd4a23f8f9ad9813c1c-dev",
    "aws_user_files_s3_bucket_region": "ca-central-1",
};


export default awsmobile;
